<template>
  <div class="about-us" id="detail">
    <Scrollama @step-enter="stepEnterHandler">
      <div class=" step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.content}}</div>
        </div>
      </div>
      <div class=" step2" data-step="b">
        <div class="post">
          <div class="item-left">
            <div :class="activeIndex == index ? 'item is-active': 'item'" v-for="(item,index) in postList" :key="index" @click="assignmentFn(item, index)">
              <div class="top">
                <div class="secondary-title secondary-title">{{ item.position }}</div>
                <div class="secondary-title salary">{{ item.salary }}</div>
              </div>
              <div class="center">
                <div class="cs">{{ item.t1 }}</div>
                <div class="jy">{{ item.t4 }}</div>
                <div class="xl">{{ item.t2 }}</div>
                <div class="qy">{{ item.t3 }}</div>
              </div>
              <div class="bottom">
                <div>{{ item.pd1 }}</div>
                <div>|</div>
                <div>{{ item.pd2 }}</div>
                <div>|</div>
                <div>{{ item.pd3 }}</div>
                <div>|</div>
                <div>{{ item.pd4 }}</div>
              </div>
            </div>
          </div>
          <div class="item-right">
            <div class="header">
              <div class="top first-level-title">
                <div class="">{{ obj.position }}</div>
                <div class="salary">{{ obj.salary }}</div>
              </div>
              <div class="bottom">
                <div>{{ obj.t1 }}</div>
                <div>|</div>
                <div>{{ obj.t2 }}</div>
                <div>|</div>
                <div>{{ obj.t3 }}</div>
                <div>|</div>
                <div>{{ obj.t4}}</div>
              </div>
            </div>
            <div class="content">
              <div class="content-top">
                <div class="top-header secondary-title">职位描述</div>
                <div class="tag">
                  <div>{{ obj.pd1 }}</div>
                  <div>{{ obj.pd2 }}</div>
                  <div>{{ obj.pd3 }}</div>
                  <div>{{ obj.pd4 }}</div>
                </div>
              </div>
              <div class="content-center">
                <div class="center-title">职位要求：</div>
                <div class="center-content">
                  <div style="margin-bottom: 10px ;" v-html="obj.pa"></div>
                </div>
              </div>
              <div class="content-bottom">
                <div class="top-header secondary-title">联系我们</div>
                <ul>
                  <li><img src="../../static/images/enterpriseRecruitment/info-icon3.png"/>
                    <div>{{ obj.phone }}</div>
                  </li>
                  <li><img src="../../static/images/enterpriseRecruitment/info-icon2.png"/>
                    <div>{{ obj.mailbox }}</div>
                  </li>
                  <li><img src="../../static/images/enterpriseRecruitment/info-icon1.png"/>
                    <div>{{ obj.地址 }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
    <footer-item></footer-item>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../home/components/footer-item'

export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      textData: {},
      obj: {},
      postList: [],
      activeIndex: 0
    }
  },
  methods: {
    assignmentFn (val, index) {
      this.activeIndex = index
      this.obj = this.postList[index]
    },
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
        case 'step6':
          this.show5 = true
          break
      }
    }
  },
  mounted: function () {
    document.getElementById('detail').scrollTop = 0
    if (this.$boss) {
      this.textData = this.$boss.page611.g611[0]
      let list = [...this.$boss.page616.g616]
      this.postList = list.reverse()
      this.activeIndex = this.$route.query.type
      this.obj = this.postList[this.$route.query.type]
      // this.obj.convert = this.obj.pa.split('=')
      // this.obj.convert.pop()
    }
  }
}
</script>
<style scoped lang="less">
  .about-us {
    width: 100%;
    height: 100%;
    font-weight: '微软雅黑';
    overflow: auto;
    div {
      //一级标题
      .first-level-title {
        font-size: 42px;
        font-weight: bold;
        color: #323232;
      }

      //二级标题
      .secondary-title {
        font-size: 24px;
        font-weight: bold;
        color: #323232;
      }

      //正文
      .text {
        font-size: 20px;
        color: #323232;
        margin-top: 70px;
      }

      //背景图宽度保持不变类
      .bg-img-maintain {
        background-size: cover !important;
        background-position: center !important;
      }

      .head {
        height: 71vh;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        /*padding-left: 100px;*/
        /*background: url("../../static/images/enterpriseRecruitment/banner.png") no-repeat;*/

        img {
          width: 100%;
          height: 100%;
        }

        .title {
          font-size: 52px;
          opacity: 0;
          margin-top: -45vh;
          font-weight: bold;
          color: #fff;
          padding-left: 100px;
        }

        .content {
          font-size: 32px;
          padding-left: 100px;
          opacity: 0;
          margin-top: 40px;
          color: #E6E9F3;
        }

        .btn {
          font-size: 22px;
          margin-top: 110px;
          width: 215px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          color: transparent;
          border: 1px solid transparent;
          margin-bottom: 110px;
        }

      }

      .post {
        border: 1px solid rgba(0, 0, 0, 0);
        width: 100%;
        padding: 100px 100px 100px 100px;
        display: flex;
        box-sizing: border-box;
        background-color: #EDF5FF;
        display: flex;

        .item-left {
          .is-active {
            border: 1px solid #5084F7;
          }
          .item {
            padding: 60px 50px;
            height: 253px;
            width: 554px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background-color: #fff;
            border-radius: 10px;
            box-shadow: rgba(203, 203, 203, 0.24) 0px 0px 10px;
            margin-bottom: 40px;

            .top {
              display: flex;
              justify-content: space-between;

              .salary {
                color: red !important;
              }
            }

            .center {
              display: flex;
              justify-content: space-between;
              height: 41px;

              div {
                line-height: 41px;
                background-color: #EBF1FE;
                color: #5084F7;
                padding: 0 10px;
                font-size: 20px;
              }
            }

            .bottom {
              font-size: 20px;
              display: flex;
              justify-content: space-between;
              color: rgba(31, 31, 31, 0.8);
            }
          }
        }

        .item-right {
          flex: 1;
          margin-left: 40px;

          .header {
            width: 100%;
            height: 194px;
            padding: 50px;
            background: url("../../static/images/enterpriseRecruitment/info-header-bg.png") no-repeat;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;

            .top {
              display: flex;
              justify-content: space-between;
              width: 500px;

              .salary {
                color: red !important;
              }
            }

            .bottom {
              width: 300px;
              display: flex;
              justify-content: space-between;
              color: rgba(31, 31, 31, 0.8);
            }
          }

          .content {
            width: 100%;
            background-color: #fff;
            padding: 50px;
            text-align: left;
            box-sizing: border-box;
            border-bottom-right-radius: 20px;
            border-bottom-left-radius: 20px;
            box-shadow: 0px 0px 20px rgba(196, 196, 196, 0.2);

            .content-top {
              // text-align:left;
              height: 140px;
              border-bottom: 1px solid #f4f4f4;
              // display:flex;
              // justify-content:space-between;
              // flex-direction:column;
              // height:100px;
              .top-header {
              }

              .tag {
                display: flex;
                justify-content: space-between;
                height: 41px;
                //   font-size:20px;
                width: 400px;
                margin-top: 40px;

                div {
                  line-height: 41px;
                  background-color: #EBF1FE;
                  color: #5084F7;
                  padding: 0 10px;
                  font-size: 20px;
                }
              }
            }

            .content-center {
              padding-bottom: 20px;
              border-bottom: 1px solid #f4f4f4;

              .center-title {
                margin-top: 20px;
                font-size: 20px;
                color: rgba(31, 31, 31, 0.8)
              }

              .center-content {
                margin-top: 20px;
                font-size: 20px;
                color: rgba(31, 31, 31, 0.8);
              }
            }

            .content-bottom {
              padding: 20px 0;

              ul {
                list-style-type: none;
                padding: 0;
                margin: 0;

                li {
                  display: flex;
                  margin-top: 20px;

                  div {
                    margin-left: 20px;
                  }
                }
              }
            }
          }
        }
      }

    }
  }

  /deep/ .el-carousel {
    width: 100%;
    height: 100%;

  }

  /deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  .animation {
    animation: revealAnimation 2s forwards;
    transform: translateY(100%);
  }

  //从下到上逐渐显示
  @keyframes revealAnimation {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/enterpriseRecruitment/recruitmentDetails.vue